import AddUnitTypeButton from '../common/header/AddUnitTypeButton';

const PropertySettingsUnitTypesTabHeader = () => {
  return <AddUnitTypeButton />;
};

export default PropertySettingsUnitTypesTabHeader;
